// https://vuex.vuejs.org/en/getters.html

export default {
  shops(state) {
    return state.shops.data;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  loaded(state) {
    return state.loaded;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
